import { useState } from "react";

export const InputFieldComponent = ({
  label,
  value,
  defaultValue,
  optional = false,
  fieldType = "text",
  inputMode = "text",
  icon,
  disabled = false,
  readOnly = false,
  error = "",
  maxLength,
  minLength,
  isAutoFocused = true,
  handleKeyDown = () => {},
  onInput = () => {},
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const getBorderColor = () => {
    if (error) return "border-red";
    if (isFocused) return "border-[#F46C3C]";
    return "border-[#D9D9D9]";
  };

  return (
    <div className="flex flex-col gap-2 w-full">
      <label className="ml-1 text-xs font-bold">
        {label}
        {optional && <span className="text-grey-600 font-medium text-sm ml-2">(optional)</span>}
      </label>
      <div className="relative w-full">
        <input
          {...props}
          {...(value !== undefined ? { value } : { defaultValue: defaultValue || "" })}
          type={fieldType}
          inputMode={inputMode}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          readOnly={readOnly}
          autoFocus={isAutoFocused}
          className={`w-full h-11 !py-3 !px-4 text-base font-medium border !${getBorderColor()} rounded-xl focus:outline-none ${
            disabled ? "text-grey-600 bg-grey-50 cursor-not-allowed" : ""
          }`}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onInput={onInput}
          maxLength={maxLength}
          minLength={minLength}
        />
        {icon && <div className="absolute inset-y-0 right-2 flex items-center">{icon}</div>}
      </div>
      {error && <span className="ml-1 text-red text-xs font-bold">{error}</span>}
    </div>
  );
};
